export default __webpack_public_path__ + "static/media/C2_21_x_29.7_Blanc.6b2292a3.jpg";